function sliderMain() {
    var swiper = new Swiper('.main .swiper', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.main .swiper-button-next',
            prevEl: '.main .swiper-button-prev',
        }
    })
}

function sliderAdvantages() {
    var swiper = new Swiper('.advantages .swiper', {
        slidesPerView: 4,
        spaceBetween: 15,
        navigation: {
            nextEl: '.advantages .swiper-button-next',
            prevEl: '.advantages .swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            400: {
                slidesPerView: 2,
            },
            451: {
                slidesPerView: 3,
            }
        }
    })
}

function sliderRooms() {
    var swiper = new Swiper('.rooms .swiper', {
        slidesPerView: 3,
        spaceBetween: 100,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: '.rooms .swiper-button-next',
            prevEl: '.rooms .swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 15,
                centeredSlides: false,
            },
            451: {
                slidesPerView: 2,
                spaceBetween: 55,
                centeredSlides: false,
            },
            577: {
                slidesPerView: 3,
                spaceBetween: 35,
            },
            769: {
                slidesPerView: 3,
                spaceBetween: 50,
            },
            993: {
                slidesPerView: 3,
                spaceBetween: 100,
            }
        }
    })
}

function sliderServices() {
    var swiper = new Swiper('.services .swiper', {
        slidesPerView: 2,
        navigation: {
            nextEl: '.services .swiper-button-next',
            prevEl: '.services .swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            451: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            577: {
                slidesPerView: 2,
                spaceBetween: 45,
            }
        }
    })
}

function sliderAdvantage2() {
    var swiper = new Swiper('.advantages2 .swiper', {
        slidesPerView: 2,
        navigation: {
            nextEl: '.advantages2 .swiper-button-next',
            prevEl: '.advantages2 .swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            577: {
                slidesPerView: 2,
                spaceBetween: 70,
            },
        }
    })
}

function sliderStaff() {
    var swiper = new Swiper('.staff .swiper', {
        slidesPerView: 3,
        spaceBetween: 60,
        navigation: {
            nextEl: '.staff .swiper-button-next',
            prevEl: '.staff .swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            577: {
                slidesPerView: 2,
                spaceBetween: 40,
            },
            769: {
                slidesPerView: 2,
                spaceBetween: 75,
            },
            993: {
                slidesPerView: 3,
                spaceBetween: 60,
            },
        }
    })
}

function sliderOffers() {
    var swiper = new Swiper('.offers .swiper', {
        slidesPerView: 1,
        navigation: {
            nextEl: '.offers .swiper-button-next',
            prevEl: '.offers .swiper-button-prev',
        }
    })
}

function gallery() {
    var swiper = new Swiper(".gallery .mySwiper", {
        slidesPerView: 3,
        spaceBetween: 20,
        freeMode: true,
        watchSlidesProgress: true,
        direction: "horizontal",
    });
    var swiper2 = new Swiper(".gallery .mySwiper2", {
        spaceBetween: 10,
        slidesPerView: 1,
        thumbs: {
            swiper: swiper,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}


$(document).ready(function() {

    sliderMain();
    sliderAdvantages();
    sliderRooms();
    sliderServices();
    sliderAdvantage2();
    sliderStaff();
    sliderOffers();
    gallery();


    // Hover-Click
    $(".header__item").hover(onIn, onOut);
    $(".header__item .header__item-show").click(function() {
        if ($(this).parents(".header__item").hasClass("header__item--active")) {
            $(this).parents(".header__item").removeClass("header__item--active")
        } else {
            $(this).parents(".header__item").addClass("header__item--active")
        }
    })

    let ItemShow = $('.header__item-show')
    let Item = $('.header__item')

    $(document).mouseup(function (e) {
        if ( !ItemShow.is(e.target) && ItemShow.has(e.target).length === 0 &&
            !Item.is(e.target) && Item.has(e.target).length === 0

        ) {
            Item.removeClass('header__item--active')
        }
    })

    // Burger - Menu
    $('.header__burger').click(function () {
        $(this).toggleClass('header__burger--active')
        $('.header__center').toggleClass('header__center--active')
        $('body').toggleClass('fixed-body')
        $('.sidebar').toggleClass('sidebar--active')
    })

    // Accordion
    $(".sidebar__item-show").click((function() {
        if($(this).parent(".sidebar__item").hasClass("sidebar__item--active")){
            $(".sidebar__item").removeClass("sidebar__item--active")
        } else{
            $(".sidebar__item").removeClass("sidebar__item--active")
            $(this).parent(".sidebar__item").toggleClass("sidebar__item--active")
        }
    }));

    $('.main__slider').click(function () {
        $('.sidebar__item').removeClass('sidebar__item--active')
    })

    $(document).mouseup( function(e) {
        var div = $( ".sidebar__item" );
        if ( !div.is(e.target)
            && div.has(e.target).length === 0 ) {
            if ($(div).hasClass("sidebar__item--active")){
                $(div).removeClass("sidebar__item--active")
            }
        }
    });

    // Up
    var btn = $('.up');
    $(window).scroll(function() {
        if ($(window).scrollTop() > 300) {
            btn.addClass('up--active');
        } else {
            btn.removeClass('up--active');
        }
    });
    btn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop:0}, '300');
    });

    // Tabs
    $(".tab").click(function () {
        let path = $(this).attr("data-tab-path")
        $(this).siblings(".tab").removeClass("tab--active")
        $(this).addClass("tab--active")

        $(this).parents(".tabs").find(".tabs__content").removeClass("tabs__content--active")
        $(this).parents(".tabs").find(`.tabs__content[data-content-path="${path}"]`).addClass("tabs__content--active")
    })

    // modal

    $("[data-modal]").click(function () {
        let modalId = $(this).attr("data-modal")

        openModal(modalId)
    })

    function openModal(modalId){
        $(`#${modalId}`).addClass("modal--active")
        $("body").addClass("fixed-body")
    }

    $(".modal").click(function () {
        closeModal()
    })

    $("._close-modal").click(function () {
        closeModal()
    })

    $(".modal__dialog").click(function (e) {
        e.stopPropagation()
    })


    function closeModal() {
        $('.modal').removeClass("modal--active")
        $("body").removeClass("fixed-body")
    }

})

function onIn() {
    if (window.innerWidth > 768) {
        let el = $(this)
        setTimeout(function() {
            if (el.is(':hover')) {
                console.log(el)
                el.addClass("header__item--active")

            }
        }, 200);
    }
}

function onOut() {
    if (window.innerWidth > 768) {
        $(this).removeClass("header__item--active")
    }
}